module.exports = __webpack_public_path__ + "static/img/andy.6854f6f7.png";